import React from 'react'

import { Image, Button } from 'react-bootstrap'
import { Link } from 'react-router-dom'
import moment from 'moment'

import SmallLogo from '../../components/SmallLogo'
import ActiveStatus from '../../components/ActiveStatus';

import Styles from './HomeScreen.module.scss'

const HomeScreen = () => {

  const signHandler = () => {
    window.location.href = "https://beyondthewhiteboard.com/earned/challenges/4"
  }

  const isClosed = () => {
    return moment('2021-12-13 19:59:59-07:00').isBefore(moment());
  }

  return (
    <>
      <div className={Styles.poster}></div>

      <div className={Styles.container}>
        <div className={Styles.right}>
          <div className={Styles.content}>
            <h2>Masters Throwdown</h2>
            <h3>Challenge details</h3>
            <p>December 10 at 6am PST - December 13 at 5pm PST</p>
            <ActiveStatus />

            <SmallLogo topTitle='Charity' className={Styles.charity} imageName="charity" />
            <p>Formerly known as Steve’s Club National Program, Forging Youth Resilience (FYR) is a member-based 501(c)(3) nonprofit organization that partners with fitness facilities nationwide to bring fitness, nutrition, and mentorship to youth who otherwise would not have access to these services. </p>
            {!isClosed() &&
              <div className={Styles.action}>
                <Button
                  variant='primary'
                  className={Styles.btn}
                  onClick={signHandler}
                >
                  Sign up
                </Button>
              </div>
            }

            <div className={Styles.textBox}>
              <h3>Price</h3>
              <p className={Styles.light}>
                <span>$20</span>
              </p>
              <Link to="/prvnmastersthrowdown/workouts">View Workouts</Link>
            </div>

            <div className={[Styles.textBox, Styles.badge].join(' ')}>
              <h3>MASTERS THROWDOWN BADGE</h3>
              <div className={Styles.icon}></div>
              <p>An exclusive btwb badge earned by registering and participating in the Masters Throwdown.</p>
            </div>

            <div className={[Styles.textBox, Styles.contact].join(' ')}>
              <h3>Contact</h3>
              <a href='mailto:support@btwb.com'>support@btwb.com</a>
            </div>
          </div>
        </div>

        <div className={Styles.left}>
          <div className={Styles.content}>
            <p>
              Welcome to the PRVN Fitness, Masters Throwdown presented by btwb. This is a global competition available for all Masters athletes of all abilities to sign up and showcase their fitness. This challenge is about community and giving the Masters athletes of our sport an opportunity to test themselves alongside one another and share in the success that comes with competitions.
            </p>
            <div className={Styles.howBlock}>
              <h3>How it works</h3>
              <ul>
                <li>Register using the Sign Up button</li>
                <li>Review the rules and video submission guidelines</li>
                <li>Do the workouts</li>
                <li>Log your score to btwb & attach the videos to be eligible to win major prizes</li>
                <li>Await a judging team member's ruling</li>
                <li>Receive your challenge badge</li>
              </ul>
              <p>
                Scores & videos need to be completely finished uploading no later than Monday 13th of December @ 5:00pm PST. Be sure to allow sufficient time to submit your scores and upload your videos.
              </p>
            </div>
            <h2>Prizes</h2>
            <h3>1st Place:</h3>
            <ul className={Styles.prizeList}>
              <li>EVO Fre rope from RX Smart Gear</li>
              <li>$50 NOBULL Gift Card</li>
              <li>1 year of ROMWOD</li>
              <li>14oz PRVN Logo YETI Mug</li>
            </ul>

            <h3>2nd Place:</h3>
            <p className={Styles.marginBottom}>50% off EVO Fre Rx Smart Gear rope</p>

            <h3>3rd Place:</h3>
            <p className={Styles.marginBottom}>25% off EVO Fre Rx Smart Gear rope</p>

            <h3>Giveaway</h3>
            <p>$500 1st Phorm gift card to a randomly selected registrant</p>

            <h3>Video Verification</h3>
            <p>If you’re interested in some of the cool prizes offered by our amazing sponsors and you think you’ll finish inside of the Top 10 overall leaderboard for any of the divisions, you’ll need to submit a video for each of the challenge events. Please refer to the sample video below to make sure your videos meet the established guidelines.</p>
            <div className={Styles.youtube}>
              <div>
                <iframe src="https://www.youtube.com/embed/9PNmh88KZxA" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
              </div>
            </div>
            <h2>Give Back To Your Gym</h2>
            <p>
              Some of the best places are independently owned gyms. 
              We love their unique character and cultures. 
              These are places where we set personal records and escape to when we need to de-stress. 
              PRVN Fitness wants to honour the good work CrossFit Affiliates do throughout the world by giving back to them. 
              <b> Part of the registration fee will donate money towards your personal affiliate to thank them. </b> 
              Athletes and Gyms interested in participating can get <a href="https://btwb.blog/2021/07/01/fitness-communities-discover-new-revenue-streams/">more information here</a>.  
            </p>
            {/*<div className={Styles.video}>
              <button className={Styles.play}></button>
              <Image src='./images/video_bg.png' fluid className={Styles.big} />
            </div>*/}
            <div className={Styles.cellar}>
              {/*<SmallLogo topTitle='Charity' className={Styles.charity} imageName="charity" />
              <p>For every shirt purchased a tree will be planted.</p>*/}

              <div className={[Styles.textBox, Styles.badge].join(' ')}>
                <h3>MASTERS THROWDOWN BADGE</h3>
                <div className={Styles.icon}></div>
                <p>An exclusive btwb badge earned by registering and participating in the Masters Throwdown.</p>
              </div>

              <div className={[Styles.textBox, Styles.contact].join(' ')}>
                <h3>Contact</h3>
                <a href='mailto:support@btwb.com'>support@btwb.com</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default HomeScreen
